<template>
    <div
        :id="id"
        :class="classObject"
        :style="{ display: 'flex' }"
        v-if="!!hasItems"
    >
        <btn
            :action="toggleOpen"
            :active="open"
            header
            :title="title"
            :icon="icon"
            :src="src"
            :iconSize="!!iconBig ? 'large' : null"
        />
        <dropdown
            v-if="!!openDropdown"
            :items="items"
            :header="header"
            :footer="footer"
        ></dropdown>
    </div>
    <btn
        header
        :title="title"
        :icon="icon"
        :href="href"
        :src="src"
        :iconSize="!!iconBig ? 'large' : null"
        :action="clickObject"
        v-else
    />
</template>

<script>
export default {
    data: () => ({
        open: false
    }),
    props: {
        id: {
            type: String,
            default: null,
            required: false
        },
        icon: {
            type: Array,
            default: null,
            required: false
        },
        href: {
            type: String,
            default: null,
            required: false
        },
        title: {
            type: String,
            default: null,
            required: false
        },
        src: {
            type: String,
            default: null,
            required: false
        },
        items: {
            type: Array,
            default: null,
            required: false
        },
        header: {
            type: Object,
            default: null,
            required: false
        },
        footer: {
            type: Object,
            default: null,
            required: false
        },
        iconBig: {
            type: Boolean,
            default: false,
            required: false
        },
        action: {
            type: Function,
            default: null,
            required: false
        }
    },
    computed: {
        classObject: function() {
            return {
                dropdown: !!this.items && !!this.items.length
            };
        },
        openDropdown: function() {
            return !!this.open && !!this.items && !!this.items.length;
        },
        hasItems: function() {
            return !!this.items && !!this.items.length;
        }
    },
    methods: {
        toggleOpen: function() {
            this.open = !!this.open ? false : true;
        },
        clickObject: function() {
            return !!this.action ? this.action.apply(this) : null;
        }
    }
};
</script>
